import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

const Checkbox = ({settings = {}}) => {
    return (
        <InputWrapper className="checkbox">
            <input type="checkbox" readOnly/>
            <div className="description">
                <span className={classNames({"required": settings.required})}>{settings.title}</span>
                {settings.description && <p>{settings.description}</p>}
            </div>
        </InputWrapper>
    )
};

export default Checkbox;